import { useCallback, useState, useEffect } from 'react';
import { Logger } from '../utils';

export default function useAddGuestToggle() {
    const [showGuestLinkModal, setShowGuestLinkModal] = useState(false);

    useEffect(() => {
        Logger(`UI.Twilio.Room.AddGuest.${showGuestLinkModal ? "Opened" : "Closed"}`, new Date());
    }, [showGuestLinkModal]);

    const toggleGuestLinkModal = useCallback((value) => {
        if (value === false || value === true) {
            setShowGuestLinkModal(value);
        } else {
            setShowGuestLinkModal(showGuestLinkModal => !showGuestLinkModal);
        }
    }, [showGuestLinkModal]);

    return [showGuestLinkModal, toggleGuestLinkModal];
}
